import withStep from '@/containers/withStep';

import CompanyDetailsWithoutOperatingAddress from './variants/CompanyDetailsWithoutOperatingAddress';
import DefaultCompanyDetails from './variants/DefaultCompanyDetails';

export const VARIANTS = [CompanyDetailsWithoutOperatingAddress, DefaultCompanyDetails];

export default withStep('CompanyDetails', {
  id: 'company-details',
  description: 'Collects the address information for the merchant',
  variants: VARIANTS,
});
